import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { ChartComponent } from '../../../../shared/components/chart/chart.component'
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ChipModule } from 'primeng/chip';
import { HeadingComponent } from '../../../../shared/components/heading/heading.component'
import { ProjectService } from '../../../../shared/services/project.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import moment from 'moment';
import { TimeKeepingService } from '../../../../shared/services/time-keeping.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { UserService } from '../../../../shared/services/user.service';
import { EmittersService } from '../../../../shared/services/emitters.service';
import { Subscription } from 'rxjs';
import { SearchMarketService } from '../../../../shared/services/search-market.service';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../shared/services/helper.service';
@Component({
  selector: 'app-overview',
  standalone: true,
  imports: [ChartComponent, ChipModule, FormsModule, ButtonModule, DropdownModule, HeadingComponent, RouterModule, CommonModule, MultiSelectModule, PipesModule],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class OverviewComponent implements OnInit, OnDestroy {
  checked: boolean = false;
  chartLabels: any = [];
  datasets = [
    {
      label: 'Graph',
      data: [],
      backgroundColor: ['rgba(255, 159, 64, 0.2)'],
      borderColor: ['rgb(255, 159, 64)'],
      borderWidth: 1,
    }
  ]
  firmId = '';
  selectedCity: any;
  projectSnapshots: any;
  projectDetails: any;
  projects: any;
  projectRoles: any;
  selectedProjects: any = [];
  selectedProjectNames: any = [];
  selectedRoles: any = [];
  selectedRoleNames: any = [];
  dailyDuration = { hours: '00', minutes: '00', seconds: '00' };
  weekDuration = { hours: '00', minutes: '00' };
  totalDuration = { hours: '00', minutes: '00' };
  headingButton = {
    url: '/client/project/create',
    label: 'CREATE PROJECT'
  }
  searchMarketsSelecterEmitter: Subscription | undefined;
  
  constructor(
    private projectService: ProjectService, 
    private userService: UserService,
    private timeKeepingService: TimeKeepingService, 
    private router:Router,
    private emittersService: EmittersService,
    private searchMarketService: SearchMarketService,
    public helperService: HelperService
  ) {}
  

  ngOnInit() {

    const user = this.userService.getSessionUser();

    this.firmId = this.userService.getUserFirmId();
    this.initialization();  
    this.subscribeEvents();  
  }

  ngOnDestroy(): void {
    this.searchMarketsSelecterEmitter && this.searchMarketsSelecterEmitter.unsubscribe();
  }

  subscribeEvents(){
    this.emittersService.myProjectEmitter.subscribe(() => {
      this.initialization();
    });
    this.searchMarketsSelecterEmitter = this.emittersService.searchMarketSelectorEmitter.subscribe(()=>{
      this.getProjects();
      this.getProjectsOverview();
      this.initializeBindingsIfSelectedProjectNotExistOnSelectedMarket();
    });
  }

  initialization(){
    this.getProjectsOverview();

    this.getProjects();

    this.getTsheetList();
  }

  async getProjectsOverview(){
    const searchMarkets = this.searchMarketService.getSearchMarkets();
    const overview = await this.projectService.getProjectsOverviewByMarket(searchMarkets || 'all');
    this.projectSnapshots = [
      {
        title: "Published Projects",
        count: overview ? (overview.PUBLISHED ? overview.PUBLISHED.count : 0) : 0,
        class: this.helperService.getEnvironmentName()+'-icon icon-published-with-changes-outlined published',
        route: '/client/project/published'
      },
      {
        title: "Unpublished Projects",
        count: overview ? (overview.CREATED ? overview.CREATED.count : 0) : 0,
        class: this.helperService.getEnvironmentName()+'-icon icon-unpublished-outlined unpublished',
        route: '/client/project/unpublished'
      },
      {
        title: "Started Projects",
        count: overview ? (overview.STARTED ? overview.STARTED.count : 0) : 0,
        class: this.helperService.getEnvironmentName()+'-icon icon-restart-alt-outlined started',
        route: '/client/project/started'
      },
      {
        title: "Archived Projects",
        count: overview ? (overview.ARCHIVED ? overview.ARCHIVED.count : 0) : 0,
        class: this.helperService.getEnvironmentName()+'-icon icon-archive-outlined archived',
        route: '/client/project/archived'
      }
    ]

    this.projectDetails = [];

    if(overview.CREATED){
      this.projectDetails.push({
        heading: 'Last Project Edited',
        project: overview.CREATED
      });
    }
    if(overview.PUBLISHED){
      this.projectDetails.push({
        heading: 'Last Project Published',
        project: overview.PUBLISHED
      });
    }
    if(overview.STARTED){
      this.projectDetails.push({
        heading: 'Last Project Started',
        project: overview.STARTED
      });
    }
  }

  getProjects(){
     const searchMarkets = this.searchMarketService.getSearchMarkets();
    this.projectService.getProjectsByFirmAndMarkets(this.firmId, searchMarkets ? searchMarkets.split(',') : [], ['STARTED', 'PUBLISHED']).subscribe({
      next: (projects) => {
        this.projects = projects;
      }
    })
  }

  getProjectRoles(){
    // reset role values
    this.selectedRoles = [];
    this.selectedRoleNames = [];

    this.projectService.getMultipleProjectRoles(this.selectedProjects).subscribe({
      next: (roles) => {
        this.projectRoles = roles;
      }
    })
  }

  onProjectChange(event: any) {
    this.selectedProjects = event.value;
    const selectedProjectsObj = this.projects.filter((e: any) => this.selectedProjects.includes(e._id));
    this.selectedProjectNames = selectedProjectsObj.map((e: any) => e.codeName);
    this.getProjectRoles();
    this.getTsheetList();
  }

  onProjectRemove(event: any) {
    const selectedProjectName = event;
    const selectedProjectId = this.projects.find((e: any) => e.codeName === selectedProjectName)?._id;
    this.selectedProjects = this.selectedProjects.filter((e: any) => e !== selectedProjectId);
    this.getProjectRoles();
    this.getTsheetList();
  }

  onRoleChange(event: any) {
    this.selectedRoles = event.value;
    const selectedRolesObj = this.projectRoles.filter((e: any) => this.selectedRoles.includes(e._id));
    this.selectedRoleNames = selectedRolesObj.map((e: any) => e.roleType);
    this.getTsheetList();
  }

  onRoleRemove(event: any) {
    const selectedRoleName = event;
    const selectedRoleId = this.projectRoles.find((e: any) => e.roleType === selectedRoleName)?._id;
    this.selectedRoles = this.selectedRoles.filter((e: any) => e !== selectedRoleId);
    this.getTsheetList();
  }

  getCurrentWeek() {
    let startOfWeek = moment().isoWeekday(1);
    startOfWeek = startOfWeek.startOf('day');
    let endOfWeek = moment(startOfWeek).add(6, 'days');
    endOfWeek = endOfWeek.endOf('day');
    return { startDate: startOfWeek, endDate: endOfWeek };
  }

  calcTotalDuration(tsheets: any) {
    let totalSecs = 0;
    tsheets = tsheets || [];
    tsheets.forEach((tsheet: any) => {
      totalSecs += tsheet.duration;
    });
    return tsheets;
  }

  calcDailyDuration(tsheets: any) {
    let dailySecs = 0;
    tsheets = tsheets || [];
    tsheets.forEach((tsheet: any) => {
      dailySecs += tsheet.duration;
    });
    this.dailyDuration = this.timeKeepingService.secondsToHMS(dailySecs);
    return tsheets;
  }

  calcWeekDuration(tsheets: any) {
    let weekSecs = 0;
    tsheets = tsheets || [];
    tsheets.forEach((tsheet: any) => {
      if (tsheet.onTheClock) {
        let clockedInTimeSheet = tsheet.id;
      }
      weekSecs += tsheet.duration;
    });
    this.weekDuration = this.timeKeepingService.secondsToHMS(weekSecs);
    return tsheets;
  }

  getTsheetList() {
    let payload: any = {};

    let navigatedWeek = this.getCurrentWeek();
    payload = {
      firmId: this.firmId,
      projectIds: this.selectedProjects,
      roleIds: this.selectedRoles,
    };

    if (navigatedWeek && navigatedWeek.startDate) {
      payload.dateRange = navigatedWeek;
      payload.inclusive = true;
    }

    return this.timeKeepingService.getTsheetsByFirm(payload)
      .subscribe((response: any) => {

        let weekTsheets = this.calcWeekDuration(response.week);
        let tsheets = this.calcTotalDuration(response.list);
        let dailyTsheets = this.calcDailyDuration(response.daily);
        this.chartLabels = Object.keys(response.stats.weeklyDistributedHours).map(function (k) {
            let key = k;
            let x = key.split('/');
            return x[0] + '/' + x[1];
        });

        this.datasets[0].data = [];
        let graphDataPoints: any = [];
        Object.keys(response.stats.weeklyDistributedHours).forEach(function (key) {
            graphDataPoints.push(Number(response.stats.weeklyDistributedHours[key].dailyTotalHours.toFixed(2)));
        });
        this.datasets[0].data = graphDataPoints;
        this.totalDuration = response.stats.totalHoursOnProject;
      })
  }

  onEdit($event:Event, project: any): void{
    $event.stopPropagation();
    this.router.navigateByUrl(`/client/project/${project._id}/edit`);
  }

  initializeBindingsIfSelectedProjectNotExistOnSelectedMarket(){
    this.selectedProjects = [];
    this.selectedRoles = [];
    this.selectedProjectNames = [];
    this.selectedRoleNames = [];

    this.dailyDuration = { hours: '00', minutes: '00', seconds: '00' };
    this.weekDuration = { hours: '00', minutes: '00' };
    this.totalDuration = { hours: '00', minutes: '00' };

    this.chartLabels = [];

    this.datasets = [
      {
        label: 'Graph',
        data: [],
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        borderWidth: 1,
      }
    ];
  }
}
